import { ApiFunc, getInstance } from '@helpers/httpClient'

import * as API from '../constants/api'

const instance = getInstance()

export const clubEventCreate: ApiFunc<`${typeof API.CLUB_EVENT}`, 'post'> = data => instance.post(API.CLUB_EVENT, data)

export const clubEventList: ApiFunc<`${typeof API.CLUB_EVENT}`, 'get'> = data =>
  instance.get(API.CLUB_EVENT, { params: data })

export const clubEventDelete: ApiFunc<`${typeof API.CLUB_EVENT}{id}`, 'delete'> = data =>
  instance.delete(`${API.CLUB_EVENT}${'id' in data ? data.id : data.name}`)

export const clubEventChangeStatus: ApiFunc<`${typeof API.CLUB_EVENT_STATUS}`, 'put'> = data =>
  instance.put(API.CLUB_EVENT_STATUS, data)
